<div class="map-container">
  <div [id]="mapId" class="map-element" [ngClass]="{ fullsize: fullsize }"></div>
</div>
